import api from '@app/api'

import type { AblePaginatedResponseFn } from '@app/api/dtos'
import type { GetCompetitorsNetworks } from './types'
import type { CompetitorsNetworksDto } from './dtos'

const URL = '/location/competitors-networks/'

export const getCompetitorsNetworks: AblePaginatedResponseFn<
GetCompetitorsNetworks,
CompetitorsNetworksDto
> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}
